import React from 'react';
import { GhostIcon, MonitorIcon, MoonIcon, SunIcon } from 'lucide-react';
import {
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
} from '@dashboard/components/ui/dropdown-menu';
import useTheme from '@dashboard/hooks/useTheme';
import { isHalloweenSeason } from '@dashboard/lib/theme';

export const THEME_OPTIONS = [
  { value: 'light', label: 'Light', Icon: SunIcon },
  { value: 'dark', label: 'Dark', Icon: MoonIcon },
  { value: 'system', label: 'System', Icon: MonitorIcon },
];

const HALLOWEEN_OPTION = { value: 'halloween', label: 'Halloween', Icon: GhostIcon };

export function getThemeOptions() {
  return isHalloweenSeason() ? [...THEME_OPTIONS, HALLOWEEN_OPTION] : THEME_OPTIONS;
}

export default function ThemeMenu() {
  const { theme, appliedTheme, setTheme } = useTheme();
  const TriggerIcon =
    theme === 'halloween' ? GhostIcon : appliedTheme === 'dark' ? MoonIcon : SunIcon;

  return (
    <DropdownMenuSub>
      <DropdownMenuSubTrigger>
        <TriggerIcon className="h-5 w-5" />
        <span>Theme</span>
      </DropdownMenuSubTrigger>
      <DropdownMenuSubContent>
        <DropdownMenuRadioGroup value={theme} onValueChange={setTheme}>
          {getThemeOptions().map(({ value, label, Icon }) => (
            <DropdownMenuRadioItem key={value} value={value} className="gap-2">
              <Icon className="h-4 w-4" />
              {label}
            </DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>
      </DropdownMenuSubContent>
    </DropdownMenuSub>
  );
}
